import classNames from 'classnames';

import {useI18n} from '@udemy/i18n';
import {useUDData} from '@udemy/ud-data';

import styles from './banner.module.less';

export const Banner = () => {
    const {gettext} = useI18n();
    const {Config} = useUDData();

    // Validation to hide 4th value prop based on price country
    // https://udemy.atlassian.net/browse/CVR-1845
    const showFourthValueProp = Config.price_country?.id === 'US';

    return (
        <div className={classNames('ud-full-viewport-container')}>
            <div className={classNames(styles['banner-container'])}>
                <div className={classNames(styles['banner-content'], 'ud-container')}>
                    <h1
                        className={classNames(
                            styles['banner-title'],
                            'ud-decorative-heading-xxxl ',
                        )}
                    >
                        {gettext('Save on Certification Exam Vouchers')}
                    </h1>
                    <div className={classNames(styles['banner-description'])}>
                        {gettext(
                            'Udemy helps you get to your certification goals with comprehensive test prep courses, practice tests, and exam vouchers. Plus, save at least 10% when booking your exam.',
                        )}
                    </div>
                </div>
            </div>
            <div className={classNames(styles['banner-cards-container'])}>
                <div className={classNames(styles['banner-cards'])}>
                    <div className={classNames(styles['banner-card'])}>
                        <div className={classNames(styles['banner-card-title'], 'ud-heading-xl')}>
                            {gettext('Prep, practice & purchase')}
                        </div>
                        <div className={classNames(styles['banner-card-description'])}>
                            {gettext('all in one place')}
                        </div>
                    </div>
                    <div className={classNames(styles['banner-card'])}>
                        <div className={classNames(styles['banner-card-title'], 'ud-heading-xl')}>
                            {gettext('Stay on track')}
                        </div>
                        <div className={classNames(styles['banner-card-description'])}>
                            {gettext('with email reminders')}
                        </div>
                    </div>
                    <div className={classNames(styles['banner-card'])}>
                        <div className={classNames(styles['banner-card-title'], 'ud-heading-xl')}>
                            {gettext('Commit to your goals')}
                        </div>
                        <div className={classNames(styles['banner-card-description'])}>
                            {gettext('when you get your voucher now')}
                        </div>
                    </div>
                    {showFourthValueProp && (
                        <div className={classNames(styles['banner-card'])}>
                            <div
                                className={classNames(styles['banner-card-title'], 'ud-heading-xl')}
                            >
                                {gettext('Save on your exam')}
                            </div>
                            <div className={classNames(styles['banner-card-description'])}>
                                {gettext('with at least 10% off the retail price')}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
